import none from "./none.js";

export default function(series) {
  return none(series).reverse();
}



//////////////////
// WEBPACK FOOTER
// ./~/@swimlane/ngx-charts/~/d3-shape/src/order/reverse.js
// module id = 735
// module chunks = 0